export default {
      id: "star-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#star-usage",
      toString: function () {
        return this.url;
      }
    }